import { render, staticRenderFns } from "./StringTruncated.vue?vue&type=template&id=54184f40&"
import script from "./StringTruncated.vue?vue&type=script&lang=js&"
export * from "./StringTruncated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports